export default "__VITE_ASSET__6e15892a__"